import { useState, useEffect } from "react";
import type { LocalEditProps } from "../../types";

function LocalEdit({ value: propValue, render, onChange: onChangeParent }: LocalEditProps) {
  const [value, setValue] = useState(propValue);
  const [currentValue, setCurrentValue] = useState(propValue);

  // Sync with prop value when it changes
  useEffect(() => {
    if (propValue !== value) {
      setValue(propValue);
      setCurrentValue(propValue);
    }
  }, [propValue, value]);

  const onChange = (newValue: string) => {
    setCurrentValue(newValue);
  };

  const onPersist = () => {
    setValue(currentValue);
    onChangeParent(currentValue);
  };

  return render({
    value: currentValue,
    onChange,
    onPersist,
  });
}

export default LocalEdit;
